import {
  ComponentRef,
  Directive,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  Type,
  ViewContainerRef,
} from '@angular/core';

import {
  TableCell,
  TableCellAttribute,
  TableCellOnActionEvent,
  TableCellStyles,
  TableRowData,
} from '../../../interfaces/tables.interfaces';
import { CellActionTooltipValues } from '../components/cell-actions.type';
import { TableCellFactory } from './table-cell.factory';

@Directive({
  selector: '[dynamicTable]',
})
export class TableConstructorDirective implements TableCell, OnInit {
  @Input({ required: true }) public tableCellAttribute: TableCellAttribute;
  @Input({ required: true }) public tableRowData: TableRowData;
  @Input({ required: true }) public rowIndex: number;
  @Input({ required: true }) public cellIndex: number;

  @Input({ required: false }) public tableCellStyles: TableCellStyles;
  @Input({ required: false }) public isExpired = false;
  @Input({ required: false }) public redirectToLoginIfNoSession = false;
  @Input({ required: false }) public tooltipValues: CellActionTooltipValues;

  @Output() public action: EventEmitter<TableCellOnActionEvent> = new EventEmitter<TableCellOnActionEvent>();

  private component: ComponentRef<TableCell>;

  private allowedTableCellService = inject(TableCellFactory);
  private container = inject(ViewContainerRef);

  public ngOnInit(): void {
    this.checkCellType();
  }

  private checkCellType(): void {
    const cell: Type<TableCell> = this.allowedTableCellService.getCellType(this.tableCellAttribute);

    if (!cell) {
      throw new Error(`Trying to use an unsupported field type (${this.tableCellAttribute.value_class_front}).`);
    }

    this.createCell(cell);
  }

  private createCell(cell: Type<TableCell>): void {
    this.component = this.container.createComponent(cell);

    this.initializeCell();
  }

  private initializeCell(): void {
    this.component.instance.tableCellAttribute = this.tableCellAttribute;
    this.component.instance.tableRowData = this.tableRowData;
    this.component.instance.rowIndex = this.rowIndex;
    this.component.instance.cellIndex = this.cellIndex;
    this.component.instance.isExpired = this.isExpired;
    this.component.instance.redirectToLoginIfNoSession = this.redirectToLoginIfNoSession;
    this.component.instance.tooltipValues = this.tooltipValues;

    this.component.instance.action.subscribe((event: TableCellOnActionEvent) => {
      this.action.emit(event);
    });
  }
}
